/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Receipt_ErrorInputs */

const en_shipping_receipt_error = /** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt not generated yet.`)
};

const es_shipping_receipt_error = /** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El recibo aún no se ha generado.`)
};

const fr_shipping_receipt_error = /** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçu pas encore généré.`)
};

const de_shipping_receipt_error = /** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quittung noch nicht generiert.`)
};

const id_shipping_receipt_error = /** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanda terima belum dibuat.`)
};

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const ja_shipping_receipt_error = en_shipping_receipt_error;

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const zh_shipping_receipt_error = en_shipping_receipt_error;

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const ar_shipping_receipt_error = en_shipping_receipt_error;

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const it_shipping_receipt_error = en_shipping_receipt_error;

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const ru_shipping_receipt_error = en_shipping_receipt_error;

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const pt_shipping_receipt_error = en_shipping_receipt_error;

/** @type {(inputs: Shipping_Receipt_ErrorInputs) => LocalizedString} */
const ko_shipping_receipt_error = en_shipping_receipt_error;

/**
* | output |
* | --- |
* | "Receipt not generated yet." |
*
* @param {Shipping_Receipt_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_receipt_error = /** @type {((inputs?: Shipping_Receipt_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Receipt_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_receipt_error(inputs)
	if (locale === "es") return es_shipping_receipt_error(inputs)
	if (locale === "fr") return fr_shipping_receipt_error(inputs)
	if (locale === "de") return de_shipping_receipt_error(inputs)
	if (locale === "ja") return ja_shipping_receipt_error(inputs)
	if (locale === "zh") return zh_shipping_receipt_error(inputs)
	if (locale === "ar") return ar_shipping_receipt_error(inputs)
	if (locale === "id") return id_shipping_receipt_error(inputs)
	if (locale === "it") return it_shipping_receipt_error(inputs)
	if (locale === "ru") return ru_shipping_receipt_error(inputs)
	if (locale === "pt") return pt_shipping_receipt_error(inputs)
	return ko_shipping_receipt_error(inputs)
});